module.exports = __webpack_public_path__ + "fa11a68eef62eab8c48809364be07016.png";